// src/modules/LiberaProximaVenda/DocumentDetail.jsx
import React from 'react';
import './DocumentDetail.css';
import { formatarDataHora } from '../../utils/formatarDataHora';
import PopupLiberar from './PopupLiberar';
import { useAuth } from '../../context/AuthContext';

const DocumentDetail = ({ documentData, onBack }) => {
  const { user } = useAuth();

  if (!documentData) {
    return <p>Document data not available.</p>;
  }

  const handleAction = (action) => {
    console.log(`${action} confirmed for document ${documentData?.documentNumber}`);
    // Logic to handle the action will be added when connecting to services
  };

  const formattedDateTime = formatarDataHora(`${documentData.date} - ${documentData.time}`);

  return (
    <div className="container-fluid document-detail-container themeTextColorPrimary mb-2">
      {/* Main Information */}
      <div className="row mb-2">
        <div className="col-12">
          <label>Branch:</label>
          <input
            type="text"
            className="form-control"
            value={`${documentData.branch?.id} - ${documentData.branch?.name}`}
            readOnly
          />
        </div>
      </div>

      <div className="row mb-2">
        <div className="col-12">
          <label>Customer:</label>
          <input
            type="text"
            className="form-control"
            value={`${documentData.customer?.code}/${documentData.customer?.store} - ${documentData.customer?.name}`}
            readOnly
          />
        </div>
      </div>

      <div className="row mb-2">
        <div className="col-6">
          <label>Document Type:</label>
          <input
            type="text"
            className="form-control"
            value={documentData.documentType?.name}
            readOnly
          />
        </div>
        <div className="col-6">
          <label>Document Number:</label>
          <input
            type="text"
            className="form-control"
            value={documentData.documentNumber}
            readOnly
          />
        </div>
      </div>

      <div className="row mb-2">
        <div className="col-6">
          <label>Date/Time:</label>
          <input
            type="text"
            className="form-control"
            value={formattedDateTime}
            readOnly
          />
        </div>
        <div className="col-6">
          <label>User:</label>
          <input
            type="text"
            className="form-control"
            value={documentData.user}
            readOnly
          />
        </div>
      </div>

      <div className="row mb-2">
        <div className="col-12">
          <label>Status:</label>
          <input
            type="text"
            className="form-control"
            value={documentData.status}
            readOnly
          />
        </div>
      </div>

      {/* Action Buttons */}
      <div className="row mt-4">
        <div className="col-6">
          <button className="btn btn-secondary w-100" onClick={onBack}>
            Back
          </button>
        </div>
        <div className="col-6">
          <PopupLiberar
            onConfirm={handleAction}
            documentData={documentData}
            idUser={user?.id}
            userName={user?.userName}
          />
        </div>
      </div>
    </div>
  );
};

export default DocumentDetail;
